import { ICheckboxProps } from "./CheckboxTypes"

import { Checkbox as ChakraChexbox, Flex, Text } from "@chakra-ui/react"

const Checkbox: React.FC<ICheckboxProps> = ({
  isChecked,
  onChange,
  variant = "base",
  size = "base",
  iconSize = 10,
  label = "",
  value = "",
  margin = "20px 15px"
}) => {
  return (
    <Flex
      fontSize="base"
      alignItems="center"
      gap="2"
      m={margin}
      fontWeight="bold"
      color={`${isChecked ? "primary" : "main_text_color"}`}
      transition="color .3s ease"

    >
      <ChakraChexbox
        isChecked={isChecked}
        onChange={onChange}
        variant={variant}
        size={size}
        iconSize={iconSize}
      />
      {label && (
        <Text ml="7px" mr="3px">
          {label}
        </Text>
      )}
      {value && <Text backgroundColor="primary" borderRadius="12px" color="white" p="2px 5px">{`${value}`}</Text>}
    </Flex>
  )
}

export default Checkbox
